import { gql } from '@apollo/client';

// One `actions` envelope; one result per action, matched by actionType + loggedAt in user-action-ack.helpers.
// `reportsEveryAction: true` is a literal so no call site can omit it. See "recordUserSession" in CLAUDE.md.
export const RECORD_USER_SESSION = gql`
  mutation RecordUserSession($startedAt: Date!, $actions: JSONObject, $newUserId: ID, $skipDuplicateActions: Boolean) {
    recordUserSession(startedAt: $startedAt, actions: $actions, newUserId: $newUserId, skipDuplicateActions: $skipDuplicateActions, reportsEveryAction: true) {
      actionType
      loggedAt
      status
      succeeded
      refusalReason
    }
  }
`;
